import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Modal, Form, Button } from "react-bootstrap";
import axios from "axios";
import API_ROUTE from "../../utils/apiRoute";
import { GlobalContext } from "../../GlobalState";

const EditAreaModal = ({
  isShowing,
  toggle,
  areaId,
  setTitleText,
  toggleActionFeedback,
  setIsActionCompleted,
}) => {

  const [validated, setValidated] = useState(false);
  const [areaNameDefault, setAreaNameDefault] = useState("");
  const [coordinatesDefault, setCoordinatesDefault] = useState("");
  const [isActive, setIsActive] = useState(true);
  const nameRef = useState(React.createRef())[0];
  const coordinatesRef = useState(React.createRef())[0];

  const [showImageUpload, setShowImageUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { selectedSchoolCode } = useContext(GlobalContext);

  useEffect(() => {
    (async () => {
      if (areaId !== null) {
        try {
          const res = await axios.get(`${API_ROUTE}area/${areaId}/`, {
            withCredentials: true,
          });
          const { name, coordinates, isActive } = res.data.data.areaData;
          setAreaNameDefault(name);
          setCoordinatesDefault(coordinates);
          setIsActive(isActive);
        } catch (err) {
          console.error(err);
        }
      }
    })();
  }, [areaId]);

  const handleNameChange = (evt) => {
    setAreaNameDefault(evt.currentTarget.value);
  };

  const handleCoordinatesChange = (evt) => {
    setCoordinatesDefault(evt.currentTarget.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity()) {
      const dataToSend = {
        newAreaName: nameRef.current.value,
        newCoordinates: coordinatesRef.current.value,
        isActive,
      };

      try {
        await axios.patch(`${API_ROUTE}area/${areaId}`, dataToSend, {
          withCredentials: true,
        });
        setTitleText("Área alterada com sucesso!");
        setIsActionCompleted(true);
      } catch (err) {
        setTitleText(err.response?.data?.message || "Erro inesperado.");
        setIsActionCompleted(false);
      } finally {
        toggleActionFeedback();
        toggle();
      }
    } else {
      event.stopPropagation();
    }

    setValidated(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    const allowedTypes = ["image/jpeg", "image/png"];
    if (file && !allowedTypes.includes(file.type)) {
      alert("Somente arquivos JPEG ou PNG são permitidos.");
      return;
    }

    setSelectedFile(file);
  };

  const handleImageUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("schoolCode", selectedSchoolCode);
    formData.append("img", selectedFile);

    try {
      await axios.patch(`${API_ROUTE}area/${areaId}/img`, formData, {
        withCredentials: true,
      });
      setShowImageUpload(false);
      setTitleText("Imagem da Área alterada com sucesso!");
      setIsActionCompleted(true);
      toggleActionFeedback();
      toggle();
    } catch (err) {
      console.error("Error uploading image:", err);
      setTitleText(err.response?.data?.message || "Erro inesperado.");
      setIsActionCompleted(false);
      toggleActionFeedback();
      toggle();
    }
  };

  return isShowing
      ? ReactDOM.createPortal(
          <>
            <Modal
                show={isShowing}
                onHide={() => {
                  setValidated(false);
                  toggle();
                }}
            >
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Editar Área</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="validationCustomName">
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Nome da Área"
                        value={areaNameDefault}
                        onChange={handleNameChange}
                        ref={nameRef}
                    />
                    <Form.Control.Feedback type="invalid">
                      A área precisa de um nome!
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="validationCustomIsActive" className="mt-3">
                    <Form.Check
                        type="checkbox"
                        label="Ativo"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustomCoordinates">
                    <Form.Label>Coordernadas</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Coordenadas da Área"
                        name="coordinates"
                        value={coordinatesDefault}
                        onChange={handleCoordinatesChange}
                        ref={coordinatesRef}
                    />
                    <Form.Control.Feedback type="invalid">
                      A área precisa de Coordernadas!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                  <Button variant="info" onClick={() => setShowImageUpload(true)}>
                    Atualizar Imagem
                  </Button>
                  <div>
                    <Button variant="danger" onClick={toggle} style={{ marginRight: "10px" }}>
                      Cancelar
                    </Button>
                    <Button type="submit" variant="success">
                      Confirmar
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal>

            <Modal show={showImageUpload} onHide={() => setShowImageUpload(false)}>
              <Form onSubmit={handleImageUpload} encType="multipart/form-data">
                <Modal.Header closeButton>
                  <Modal.Title>Upload de Imagem</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formFile">
                    <Form.Label>Escolha uma imagem</Form.Label>
                    <Form.Control
                        type="file"
                        name="img"
                        required
                        accept=".jpeg, .png"
                        onChange={handleFileChange}
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowImageUpload(false)}>
                    Fechar
                  </Button>
                  <Button variant="primary" type="submit">
                    Enviar
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </>,
          document.body
      )
      : null;
};

export default EditAreaModal;
